module.exports = __webpack_public_path__ + "img/banner-1-m.e09b690e.jpg";